import routes from '@modules/price/price-routes';
import store from '@modules/price/price-store';

export default {
  routes,
  store,
};
